import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import * as orgActions from '../../../../redux/organisations';
import useDebouncedState from '../../../../hooks/useDebouncedState';
import { Pharmacy } from '../../../../types/pharmacy';

interface PharmacySearchReturn {
  search: (text: string) => void;
  pharmacies: Pharmacy[];
}

const usePharmacySearch = (): PharmacySearchReturn => {
  const dispatch = useDispatch();
  const searchResults = useSelector((state: RootStateOrAny) => state.organisations.searchResults);

  const search = useCallback(
    (text: string) => {
      dispatch(orgActions.search({ searchTerm: text, searchBy: 'pharmacies', isActive: true }));
    },
    [dispatch]
  );

  return { search, pharmacies: searchResults?.pharmacies || [] };
};

const useDebouncedPharmacySearch = () => {
  const { search, pharmacies } = usePharmacySearch();
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearchInput, setStateDebounced] = useDebouncedState(searchInput, 300);

  useEffect(() => {
    if (searchInput.length > 2) {
      setStateDebounced(searchInput);
    }
  }, [setStateDebounced, searchInput]);

  useEffect(() => {
    if (debouncedSearchInput.length > 2) {
      search(debouncedSearchInput);
    }
  }, [search, debouncedSearchInput]);

  return { searchInput, setSearchInput, pharmacies: pharmacies || [] };
};

export default useDebouncedPharmacySearch;
